import React, { ReactNode } from 'react'
import { Container } from './styles'

interface InputRootProps {
  children: ReactNode
  flex?: string
}

export const InputRoot = ({ flex, children }: InputRootProps) => {
  return <Container flex={flex}>{children}</Container>
}
